import { axiosClient } from 'www/utils'
import type {
  ApiPlacesParamsGet,
  ApiPlacesResponseGet,
} from 'www/vue_components/common/TheFilters/doctors/api/apiMetrosAndDistricts.types'

export default {
  get(params: ApiPlacesParamsGet) {
    return axiosClient.get<ApiPlacesResponseGet>('/api/town/metros-and-districts/', {
      params,
    })
  },
}
